import { createFileRoute } from '@tanstack/react-router'
import { AccountLink } from '../components/AccountLink'
import { ButtonLink, Label, PageTitle } from '../components/ui'
import { votes } from '../design/tokens'
import { meQuery } from '../lib/queries'

// Ryan's page. The link is hidden if this is ever emptied.
const COFFEE_URL = 'https://buymeacoffee.com/bikesandbbq'

export const Route = createFileRoute('/about')({
  // Anyone can read this page. If they're signed in we want to know, so the
  // account link shows; if they aren't, that's fine too.
  beforeLoad: ({ context }) => context.queryClient.ensureQueryData(meQuery).catch(() => undefined),
  component: About,
})

function About() {
  return (
    <div className="mx-auto grid w-full max-w-[560px] gap-5 px-4 pb-16 pt-[calc(env(safe-area-inset-top,0px)+24px)]">
      <div className="flex items-start justify-between gap-3">
        <PageTitle eyebrow="About">An excuse to share cat pictures</PageTitle>
        <AccountLink className="mt-1 flex-none" />
      </div>
      <p className="text-[15.5px]">Cat Bowl is a weekly photo contest for a group of friends. The scoring exists to keep everyone posting. The cats don't know they're competing, which is for the best.</p>
      <section className="grid gap-2.5">
        <Label>How a round works</Label>
        <ul className="grid gap-2 text-[15px] [&>li]:grid [&>li]:grid-cols-[auto_1fr] [&>li]:gap-x-2.5">
          {[
            ['Sunday to Saturday', 'Three categories. Post photos or short videos of your cats, as many as you like up to the league limit.'],
            ['Sunday and Monday', `Everyone gets five ${votes(5)} per category to hand out however they please. Your own posts are off limits, and tallies stay hidden.`],
            ['Tuesday', 'Results post. Blue rosette for first, red for second, yellow for third, like a real cat show.'],
          ].map(([t, d]) => (
            <li key={t}><span aria-hidden className="mt-[8px] size-2 rounded-full bg-accent" /><span><b className="font-semibold">{t}.</b> <span className="text-muted">{d}</span></span></li>
          ))}
        </ul>
      </section>
      <section className="grid gap-2.5">
        <Label>Points</Label>
        <p className="text-[15px] text-muted">One for each {votes(1)} your posts receive. One for posting in a category, however many times. Two for voting in every category you can. Three for winning a category; ties all win. A tie for first makes the next post third.</p>
      </section>
      <section className="grid gap-2.5">
        <Label>Your photos</Label>
        <p className="text-[15px] text-muted">Only people in your league see your posts. Location and device details are stripped from every photo and video before anyone else can load it, and your original files are never shared.</p>
      </section>
      <div className="flex flex-wrap gap-2.5">
        <ButtonLink to="/" size="sm">Back to the league</ButtonLink>
        <ButtonLink to="/privacy" size="sm">Privacy</ButtonLink>
        <ButtonLink to="/terms" size="sm">Terms</ButtonLink>
        <ButtonLink to="/copyright" size="sm">Copyright</ButtonLink>
        {COFFEE_URL && <a href={COFFEE_URL} target="_blank" rel="noreferrer" className="inline-flex items-center rounded-full px-3.5 py-[7px] text-[13.5px] font-semibold ring-[1.5px] ring-inset ring-line">Buy me a coffee</a>}
      </div>
    </div>
  )
}
